var h = Object.defineProperty;
var Q = (I, M, e) => M in I ? h(I, M, { enumerable: !0, configurable: !0, writable: !0, value: e }) : I[M] = e;
var T = (I, M, e) => (Q(I, typeof M != "symbol" ? M + "" : M, e), e), y = (I, M, e) => {
  if (!M.has(I))
    throw TypeError("Cannot " + e);
};
var i = (I, M, e) => (y(I, M, "read from private field"), e ? e.call(I) : M.get(I)), z = (I, M, e) => {
  if (M.has(I))
    throw TypeError("Cannot add the same private member more than once");
  M instanceof WeakSet ? M.add(I) : M.set(I, e);
}, C = (I, M, e, N) => (y(I, M, "write to private field"), N ? N.call(I, e) : M.set(I, e), e);
var l = (I, M, e) => (y(I, M, "access private method"), e);
const Y = [
  {
    id: "argentX",
    name: "Argent X",
    icon: "data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjQwIiBoZWlnaHQ9IjM2IiB2aWV3Qm94PSIwIDAgNDAgMzYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yNC43NTgyIC0zLjk3MzY0ZS0wN0gxNC42MjM4QzE0LjI4NTEgLTMuOTczNjRlLTA3IDE0LjAxMzggMC4yODExNzggMTQuMDA2NCAwLjYzMDY4M0MxMy44MDE3IDEwLjQ1NDkgOC44MjIzNCAxOS43NzkyIDAuMjUxODkzIDI2LjM4MzdDLTAuMDIwMjA0NiAyNi41OTMzIC0wLjA4MjE5NDYgMjYuOTg3MiAwLjExNjczNCAyNy4yNzA5TDYuMDQ2MjMgMzUuNzM0QzYuMjQ3OTYgMzYuMDIyIDYuNjQwOTkgMzYuMDg3IDYuOTE3NjYgMzUuODc1NEMxMi4yNzY1IDMxLjc3MjggMTYuNTg2OSAyNi44MjM2IDE5LjY5MSAyMS4zMzhDMjIuNzk1MSAyNi44MjM2IDI3LjEwNTcgMzEuNzcyOCAzMi40NjQ2IDM1Ljg3NTRDMzIuNzQxIDM2LjA4NyAzMy4xMzQxIDM2LjAyMiAzMy4zMzYxIDM1LjczNEwzOS4yNjU2IDI3LjI3MDlDMzkuNDY0MiAyNi45ODcyIDM5LjQwMjIgMjYuNTkzMyAzOS4xMzA0IDI2LjM4MzdDMzAuNTU5NyAxOS43NzkyIDI1LjU4MDQgMTAuNDU0OSAyNS4zNzU5IDAuNjMwNjgzQzI1LjM2ODUgMC4yODExNzggMjUuMDk2OSAtMy45NzM2NGUtMDcgMjQuNzU4MiAtMy45NzM2NGUtMDdaIiBmaWxsPSIjRkY4NzVCIi8+Cjwvc3ZnPgo=",
    downloads: {
      chrome: "https://chrome.google.com/webstore/detail/argent-x-starknet-wallet/dlcobpjiigpikoobohmabehhmhfoodbb",
      firefox: "https://addons.mozilla.org/en-US/firefox/addon/argent-x"
    }
  },
  {
    id: "braavos",
    name: "Braavos",
    icon: "data:image/svg+xml;base64,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",
    downloads: {
      chrome: "https://chrome.google.com/webstore/detail/braavos-wallet/jnlgamecbpmbajjfhmmmlhejkemejdma",
      firefox: "https://addons.mozilla.org/en-US/firefox/addon/braavos-wallet",
      edge: "https://microsoftedge.microsoft.com/addons/detail/braavos-wallet/hkkpjehhcnhgefhbdcgfkeegglpjchdc"
    }
  }
], U = () => `${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`, w = (I) => {
  for (let M = I.length - 1; M > 0; M--) {
    const e = Math.floor(Math.random() * (M + 1));
    [I[M], I[e]] = [I[e], I[M]];
  }
  return I;
};
function s(...I) {
  return (M) => I.reduce((e, N) => e.then(N), Promise.resolve(M));
}
var A, c, u, r, S, a, n;
class f {
  constructor(M) {
    z(this, r);
    z(this, a);
    z(this, A, !1);
    z(this, c, void 0);
    z(this, u, void 0);
    T(this, "value");
    C(this, u, M), l(this, a, n).call(this);
  }
  set(M) {
    return !i(this, A) && !l(this, a, n).call(this) ? !1 : (this.delete(), this.value = M, M && (C(this, c, `${i(this, u)}-${U()}`), localStorage.setItem(i(this, c), M)), !0);
  }
  get() {
    return l(this, r, S).call(this), this.value;
  }
  delete() {
    return !i(this, A) && !l(this, a, n).call(this) ? !1 : (this.value = null, i(this, c) && localStorage.removeItem(i(this, c)), !0);
  }
}
A = new WeakMap(), c = new WeakMap(), u = new WeakMap(), r = new WeakSet(), S = function() {
  this.value && this.set(this.value);
}, a = new WeakSet(), n = function() {
  try {
    !i(this, A) && typeof window < "u" && (C(this, c, Object.keys(localStorage).find(
      (M) => M.startsWith(i(this, u))
    )), C(this, A, !0), i(this, c) && this.set(localStorage.getItem(i(this, c))));
  } catch (M) {
    console.warn(M);
  }
  return i(this, A);
};
function O(I, M) {
  var e, N;
  if ((e = M == null ? void 0 : M.include) != null && e.length) {
    const D = new Set(M.include);
    return I.filter((g) => D.has(g.id));
  }
  if ((N = M == null ? void 0 : M.exclude) != null && N.length) {
    const D = new Set(M.exclude);
    return I.filter((g) => !D.has(g.id));
  }
  return I;
}
const x = async (I) => {
  const M = await Promise.all(
    I.map((e) => e.isPreauthorized().catch(() => !1))
  );
  return I.filter((e, N) => M[N]);
}, m = (I) => {
  try {
    return I && [
      "request",
      "isConnected",
      "provider",
      "enable",
      "isPreauthorized",
      "on",
      "off",
      "version",
      "id",
      "name",
      "icon"
    ].every((M) => M in I);
  } catch {
  }
  return !1;
};
function o(I, M) {
  return Object.values(
    Object.getOwnPropertyNames(I).reduce((e, N) => {
      if (N.startsWith("starknet")) {
        const D = I[N];
        M(D) && !e[D.id] && (e[D.id] = D);
      }
      return e;
    }, {})
  );
}
const d = (I, M) => {
  if (M && Array.isArray(M)) {
    I.sort((N, D) => M.indexOf(N.id) - M.indexOf(D.id));
    const e = I.length - M.length;
    return [
      ...I.slice(e),
      ...w(I.slice(0, e))
    ];
  } else
    return w(I);
}, b = typeof window < "u" ? window : {}, E = {
  windowObject: b,
  isWalletObject: m,
  storageFactoryImplementation: (I) => new f(I)
};
function W(I = {}) {
  const { storageFactoryImplementation: M, windowObject: e, isWalletObject: N } = {
    ...E,
    ...I
  }, D = M("gsw-last");
  return {
    getAvailableWallets: async (g = {}) => {
      const t = o(
        e,
        N
      );
      return s(
        (j) => O(j, g),
        (j) => d(j, g.sort)
      )(t);
    },
    getPreAuthorizedWallets: async (g = {}) => {
      const t = o(
        e,
        N
      );
      return s(
        (j) => x(j),
        (j) => O(j, g),
        (j) => d(j, g.sort)
      )(t);
    },
    getDiscoveryWallets: async (g = {}) => s(
      (t) => O(t, g),
      (t) => d(t, g.sort)
    )(Y),
    getLastConnectedWallet: async () => {
      const g = D.get(), j = o(e, N).find(
        (k) => k.id === g
      ), [L] = await x(
        j ? [j] : []
      );
      return L || (D.delete(), null);
    },
    enable: async (g, t) => {
      if (await g.enable(t != null ? t : { starknetVersion: "v4" }), !g.isConnected)
        throw new Error("Failed to connect to wallet");
      return D.set(g.id), g;
    },
    disconnect: async ({ clearLastWallet: g } = {}) => {
      g && D.delete();
    }
  };
}
const Z = W();
export {
  Z as default,
  W as getStarknet
};
